<script lang="ts">
  import { untrack } from "svelte";
  import { api } from "@/api";
  import { token } from "@/stores/session";
  import Select from "./Select.svelte";

  interface Props {
    core: string;
    value: string;
    id?: string;
    disabled?: boolean;
    preserveUnavailable?: boolean;
    ready?: boolean;
  }
  let {
    core,
    value = $bindable(),
    id,
    disabled = false,
    preserveUnavailable = false,
    ready = $bindable(false),
  }: Props = $props();
  let versions = $state<string[]>([]);
  let loading = $state(false);
  let error = $state("");
  let retry = $state(0);
  let previousCore: string | undefined;
  const options = $derived([
    ...(preserveUnavailable && value && !versions.includes(value)
      ? [{ value, label: `${value} (текущая версия)`, disabled: true }]
      : []),
    ...versions.map((version) => ({ value: version, label: version })),
  ]);

  $effect(() => {
    const requestedCore = core;
    const auth = $token;
    void retry;
    previousCore ??= requestedCore;
    const changedCore = previousCore !== requestedCore;
    const initialValue = untrack(() => value);
    ready = false;
    loading = true;
    error = "";
    versions = [];
    const controller = new AbortController();
    if (!auth) {
      loading = false;
      return;
    }
    void api
      .coreVersions(auth, requestedCore, controller.signal)
      .then((result) => {
        if (controller.signal.aborted) {
          return;
        }
        previousCore = requestedCore;
        versions = result.versions;
        if (!versions.includes(initialValue) && (!preserveUnavailable || changedCore)) {
          value = versions[0] ?? "";
        }
        ready = versions.length > 0;
      })
      .catch((cause) => {
        if (!controller.signal.aborted) {
          error = (cause as Error).message;
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          loading = false;
        }
      });
    return () => controller.abort();
  });
</script>

<Select
  {id}
  aria-label="Версия Minecraft"
  bind:value
  {options}
  disabled={disabled || loading || !ready}
  placeholder={loading ? "Загружаем версии…" : "Выберите версию"}
/>
{#if error}
  <p class="version-error" role="alert">
    {error} <button type="button" onclick={() => (retry += 1)}>Повторить</button>
  </p>
{/if}
<style>
  .version-error {
    color: var(--mars-light);
    font-size: 0.8rem;
  }
  button {
    border: 0;
    background: transparent;
    padding: 0.2rem;
    color: var(--cream);
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
